var map = {
	"./banner_bg.png": 16385,
	"./close_icon.png": 82790,
	"./dashbg.png": 28319,
	"./faq_arrow.png": 84476,
	"./img_01.png": 91627,
	"./img_02.png": 38993,
	"./img_02_new.png": 2739,
	"./img_03.png": 60632,
	"./img_usdt.png": 10053,
	"./imgusdt.png": 68382,
	"./imgusdt1.png": 21109,
	"./list_icon.png": 66191,
	"./logo.png": 74427,
	"./metamask.png": 58843,
	"./trustwallet.png": 89414,
	"./wallet_imgbtn.png": 66461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;